import React from "react";

const NotifModal = (props) => {
  return (
    <div
      onScroll={(e) => {
        e.stopPropagation();
      }}
      className="wallet-main gift"
    >
      <div className="wallet-modal description h-400">
        <h4>{props.item.title}</h4>
        <div className="p-box mt-2">
          <p>
            {
              props.item.Content
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotifModal;
